export default __webpack_public_path__ + "c9f15668e86bf578f34b44e604f5879e.svg";